<ng-container *ngIf="inGrid">
    <ion-grid>
        <ion-row align-items-center>
            <ion-col *ngIf="labelScanner" [sizeMd]="labelSize" size="12">
                {{labelScanner}}
            </ion-col>
            <ion-col>
                <app-barcode-scanner iconHeight='4em' iconWidth='4em' liveHeight='80%' liveWidth='80%'
                                     type="inv" (code)="onReady($event)">
                </app-barcode-scanner>
            </ion-col>
        </ion-row>
        <ion-row align-items-center>
            <ion-col *ngIf="labelInput" [sizeMd]="labelSize" size="12">
                {{labelInput}}
            </ion-col>
            <ion-col [attr.data-intro]="'help.inv-input' | translate">
                <app-inventory-number-input [allowExisting]="true" [showExisting]="true" [onlyExisting]="true"
                                            [invnr]="invnr" (invnrChange)="onReady($event)" (click)="input()">
                </app-inventory-number-input>
            </ion-col>
        </ion-row>
    </ion-grid>
</ng-container>

<ng-container *ngIf="!inGrid">
    <app-barcode-scanner iconHeight='30%' iconWidth='30%' liveHeight='80%' liveWidth='80%'
                         type="inv" (code)="onReady($event)">
    </app-barcode-scanner>
    <div [attr.data-intro]="'help.inv-input' | translate">
        <app-inventory-number-input [allowExisting]="true" [showExisting]="true" [onlyExisting]="true"
                                    [invnr]="invnr" (invnrChange)="onReady($event)"
                                    (click)="input()">
        </app-inventory-number-input>
    </div>
</ng-container>
